import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { useAuthContext } from "../../context/auth";
import { useCurrency } from "../../utils";
import { asignarFacturaCajaChica } from "../../utils/asignarFacturaCajaChica";
import { getEmpleadosActivos } from "../../utils/empleados";

// "Pagada por caja chica" desde el kebab (⋮) de "Por pagar" en FlujoCajaV2: marca una factura SII recibida
// como pagada con el fondo de caja chica de un empleado activo del país. Solo capa caja chica — la
// escritura es el util asignarFacturaCajaChica (caja_chica_gastos + estado_vinculacion; no clasifica,
// 10.141/10.142). Reemplaza al tab "Caja Chica" que vivía en PlanCuotasModal (2026-09-25).
//
// onSuccess({ facturaId }) se llama cuando la factura quedó en caja_chica_gastos (éxito, parcial, o ya
// estaba de antes — 23505): en los tres casos la fila ya no es "por pagar" y el padre la saca por ID.
const AsignarCajaChicaModal = ({ isOpen, factura, onClose, onSuccess }) => {
  const { id: userId, pais } = useAuthContext();
  const { formatAmount } = useCurrency();
  const [empleados, setEmpleados] = useState([]);
  const [empleadoId, setEmpleadoId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setEmpleadoId("");
    let vigente = true;
    getEmpleadosActivos(pais)
      .then((data) => {
        if (vigente) setEmpleados(data);
      })
      .catch((err) => toast.error(`Error cargando empleados: ${err.message}`));
    return () => {
      vigente = false;
    };
  }, [isOpen, pais]);

  const proveedor = factura?.razon_social_receptor || factura?.razon_social_emisor || "Proveedor";
  const moneda = factura?.moneda_origen || (pais === "Chile" ? "CLP" : "PEN");

  const handleAsignar = async () => {
    setLoading(true);
    try {
      const res = await asignarFacturaCajaChica({ factura, empleadoId, pais, userId });
      if (res.ok) toast.success("Factura asignada a caja chica");
      else toast.error(res.error);
      if (res.gastoRegistrado || res.codigo === "ya_en_caja_chica") {
        onSuccess?.({ facturaId: factura.id });
        onClose();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "0.95rem" }}>Pagada por caja chica</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.85rem", marginBottom: 14 }}>
          {proveedor} · Folio {factura?.folio} ·{" "}
          <strong>{formatAmount(Number(factura?.monto_total || 0), moneda)}</strong>
        </div>
        <select
          className="form-control form-control-sm"
          value={empleadoId}
          onChange={(e) => setEmpleadoId(e.target.value)}
        >
          <option value="">Seleccionar empleado...</option>
          {empleados.map((emp) => (
            <option key={emp.id} value={emp.id}>
              {`${emp.nombre} ${emp.apellido || ""}`.trim()}
            </option>
          ))}
        </select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleAsignar} disabled={loading || !empleadoId}>
          {loading ? "Guardando..." : "Asignar a caja chica"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AsignarCajaChicaModal;
